import "./Playnews.css";    
import kelvin from "./playImage/kelvin.jpg";
import series from "./playImage/series.jpg";
import { NavLink, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Skeleton from "../../components/Skeleton";
import { Helmet } from "react-helmet-async";
import logo from "../../components/images/logo.png";

const Playnews = ({dark, playerData, loading, error, MyBaseUrl}) => {

    const { slug } = useParams();
    const location = useLocation();

    const [news, setNews] = useState([]);
    const [newsLoading, setNewsLoading] = useState(false);
    const [newsError, setNewsError] = useState(null);

    const fallbackPlayer = location?.state?.player || {};

    const player = playerData || {};
    const stats = playerData?.statistics?.[0] || {};
    const team = stats?.team || {};

    const passedLeagueSlug = location?.state?.leagueSlug;

    const fallbackSlug =
      stats?.league?.name
        ?.trim()
        ?.toLowerCase()
        ?.replace(/\s+/g, "") || "";

    const leagueSlug = passedLeagueSlug || fallbackSlug;

    const Name = stats?.league?.name?.trim()?.replace(/\s+/g, "-") || "Unknown-League";

    
    const CACHE_KEY = "player_news_154";
    const CACHE_TIME = 1000 * 60 * 10; 

    useEffect(() => {
      const fetchNews = async () => {
        try {
          setNewsLoading(true);

          
          const cached = localStorage.getItem(CACHE_KEY);

          if (cached) {
            const parsed = JSON.parse(cached);

            if (Date.now() - parsed.timestamp < CACHE_TIME) {
              setNews(parsed.data);
              setNewsLoading(false);
              return;
            }
          }
          
          const res = await fetch(`${MyBaseUrl}/players/154/news`);
          const data = await res.json();

          const newsData = data?.data?.data || [];

          setNews(newsData);

          localStorage.setItem(
            CACHE_KEY,
            JSON.stringify({
              data: newsData,
              timestamp: Date.now()
            })
          );

          setNewsLoading(false);
        } catch (err) {
          setNewsError("Failed to load news");
          setNewsLoading(false);
        }
      };

      fetchNews();
    }, []);

    return (

      <>
      
<Helmet>

  <title>
    {`${fallbackPlayer?.name || player?.name || "Player"} News, Updates & Headlines | FadaSports`}
  </title>

  <meta
    name="description"
    content={`Read the latest news, transfer updates, injury reports, match reactions and football headlines about ${
      fallbackPlayer?.name || player?.name || "this player"
    } from ${team?.name || "their club"} in ${
      stats?.league?.name || "football competitions"
    } on FadaSports.`}
  />

  <meta
    name="keywords"
    content={`
      ${fallbackPlayer?.name || player?.name},
      player news,
      football news,
      transfer news,
      injury updates,
      ${team?.name || ""},
      ${stats?.league?.name || ""},
      football headlines,
      breaking sports news,
      FadaSports
    `}
  />

  <meta name="author" content="FadaSports" />

  <meta name="robots" content="index, follow, max-image-preview:large" />

  <link
    rel="canonical"
    href={`https://fadasports.com/players/${slug}/news`}
  />

  {/* OPEN GRAPH */}
  <meta property="og:type" content="article" />

  <meta property="og:site_name" content="FadaSports" />

  <meta
    property="og:url"
    content={`https://fadasports.com/players/${slug}/news`}
  />

  <meta
    property="og:title"
    content={`${fallbackPlayer?.name || player?.name || "Player"} News & Updates | FadaSports`}
  />

  <meta
    property="og:description"
    content={`Latest breaking news, transfers, injuries and match stories about ${
      fallbackPlayer?.name || player?.name || "this player"
    }.`}
  />

  <meta
    property="og:image"
    content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
  />

  <meta
    property="og:image:alt"
    content={`${fallbackPlayer?.name || player?.name || "Player"} news image`}
  />

  <meta property="og:locale" content="en_US" />

  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content={`${fallbackPlayer?.name || player?.name || "Player"} News | FadaSports`}
  />

  <meta
    name="twitter:description"
    content={`Get latest headlines, transfers, injury updates and football news about ${
      fallbackPlayer?.name || player?.name || "this player"
    }.`}
  />

  <meta
    name="twitter:image"
    content={
      fallbackPlayer?.photo ||
      player?.photo ||
      {logo}
    }
  />

  <meta name="twitter:site" content="@FadaSports" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      headline: `${fallbackPlayer?.name || player?.name} Latest News and Updates`,
      image: [
        fallbackPlayer?.photo ||
          player?.photo ||
          {logo}
      ],
      datePublished: new Date().toISOString(),
      dateModified: new Date().toISOString(),
      author: {
        "@type": "Organization",
        name: "FadaSports"
      },
      publisher: {
        "@type": "Organization",
        name: "FadaSports",
        logo: {
          "@type": "ImageObject",
          url: {logo}
        }
      },
      description: `Latest breaking news, transfer stories, injury updates and match analysis for ${
        fallbackPlayer?.name || player?.name || "this player"
      } on FadaSports.`,
      mainEntityOfPage: `https://fadasports.com/players/${slug}/news`
    })}
  </script>

</Helmet>

      <div className="homer">
        
    <div className={`playerWrapper`} >

      <section className="firstsection">
        <nav>
          <img src={fallbackPlayer?.photo || player?.photo} alt="" />
          <div>
            <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
              {fallbackPlayer?.name || player?.name}
            </p>
          </div>
        </nav>

        <span>
          <strong style={dark ? {color: "#c7c7c7ff"} : {color: "#363636ff"}}>
            {(player?.age || fallbackPlayer?.age)
              ? `${player?.age || fallbackPlayer?.age} years`
              : "Loading..."}
            {" "}
            {player?.nationality || fallbackPlayer?.nationality || ""}
          </strong>

          <strong style={dark ? {color: "#c5c3c3ff"} : {color: "#3a3a3aff"}}>
            {team?.name || fallbackPlayer?.team?.name || ""}
          </strong>
        </span>

        <menu>
            <ul style={dark ? {backgroundColor: "#333333ff"} : {}}>
                <li>
                    <NavLink 
                        to={`/players/${slug}`}
                        state={{ player: fallbackPlayer, leagueSlug }}
                        className="linkname"
                        style={dark ? {color: "#fafafaff", backgroundColor: "transparent"} : {color: "#3F3E3E", backgroundColor: "transparent"}}
                    >
                        Overview
                    </NavLink>
                </li>

                <li>
                    <NavLink 
                        to={`/players/${slug}/news`} 
                        state={{ player: fallbackPlayer, leagueSlug }}
                        className="myactive"
                        style={dark ? {color: "#fafafaff"} : {}}
                    >
                        News
                    </NavLink>
                </li>

                <li>
                    <NavLink 
                        to={`/players/${slug}/statistics`} 
                        state={{ player: fallbackPlayer, leagueSlug }}
                        className="linkname"
                        style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}
                    >
                        Statistics
                    </NavLink>
                </li>
            </ul>
        </menu>
      </section>

      {loading ? (

        <Skeleton dark={dark} count={6}/>

      ) : error ? (

        <div style={{
          padding: "40px 20px",
          color: "red"
        }}>
          {error}
        </div>

      ) : !playerData ? (

        <div style={{
          padding: "40px 20px",
          color: dark ? "#fff" : "#161819"
        }}>
          No player data found.
        </div>

      ) : (

        <>
          <h1 style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>
            {fallbackPlayer?.name || player?.name} News
          </h1>

          {newsLoading ? (
            <p style={{ padding: "20px" }}>Loading news...</p>
          ) : newsError ? (
            <p style={{ padding: "20px", color: "red" }}>{newsError}</p>
          ) : (
            <>
            
              <section className="fifthsection">
                {news.slice(0, 1).map((item, index) => (
                  <NavLink 
                    key={item.id}
                    to={`/news/${item?.slug}`}
                    state={{ news: item }}
                    className="new"
                  >
                    <div 
                    // style={dark ? {backgroundColor: "#181818ff"} : {backgroundColor: ["#38BE8F", "#5126D4", "#389A3F"][index % 3]}}
                    >
                      <nav>
                        <img src={item.image || series} alt="" />
                      </nav>
                      <nav className="con deep">
                        <h2 className="mobile-title">
                          {item?.title?.length > 40
                            ? item.title.slice(0, 40) + "..."
                            : item.title}
                        </h2>

                        <h2 className="desktop-title">
                          {item?.title?.length > 150
                            ? item.title.slice(0, 150) + "..."
                            : item.title}
                        </h2>
                      </nav>
                    </div>
                  </NavLink>
                ))}
              </section>



              <section className="sixthsection">
                {news.slice(1, 10).map((item) => (
                  <NavLink 
                    key={item.id}
                    to={`/news/${item?.slug}`}
                    state={{ news: item }}
                    className="new"
                  >
                    <div 
                    style={dark ? {backgroundColor: "#1818187a"} : {backgroundColor: "#ffffffff"}}>
                      <nav>
                        <img src={item.image || series} alt="" />
                      </nav>
                      <nav className="con">
                        <h3 style={dark ? {color: "#B3B3B3"} : {color: "#3e3f3f"}}>{item.categories?.[0]?.name || "News"}</h3>
                        <h2 style={dark ? {color: "#eeeeee"} : {color: "#161819"}}>{item.title}</h2>
                        {/* <p>{item.excerpt}</p> */}
                      </nav>
                    </div>
                  </NavLink>
                ))}
              </section>
            </>
          )}
        </>
      )}
    </div>
    
      <section className="addsection"
        style={dark ? { backgroundColor: "#111111ff", color: "#fff" } : { backgroundColor: "whitesmoke" }}>
        <div className="clubteam">
          <h1>The Club Teams Resumes its Training in Preparation</h1>
          <p>Watch your favorite team compete in real-time...</p>
        </div>
      </section>
      </div>
      </>
    );
}

export default Playnews;